export const environment = {
  production: false,
  appType: 'transporter',
  appTitle: 'WP Transporter',
  authBaseUrl: '/api/v1/wp/transporter/auth/',
  saleshubPdfUrl: 'https://dev-saleshub.idfood.co.id/api/f_trans/c_subsidiary_inventory_sales_order/create_pdf_so',
  qrDomain: 'https://dev-warungpangan.idfood.co.id'
};
